import Icon from '../components/Icon.vue'

Icon.register({
  capsules: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64 307.8 64 284.9 70.7 264.9 84.7 245.2 98.5 231.2 117.5 223.4 138.5 220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144V368C0 429.9 50.1 480 112 480S224 429.9 224 368V218.9C227.3 227.5 231.3 236 236.8 243.9L368 431.2C390.2 463 425.7 480 461.8 480 484.5 480 507.3 473.3 527.3 459.3 579 423.1 591.5 351.8 555.3 300.1zM160 256H64V144C64 117.5 85.5 96 112 96S160 117.5 160 144V256zM354.8 300.9L289.2 207.2C281.5 196.2 278.5 182.8 280.9 169.6 283.2 156.4 290.6 144.8 301.6 137.1 310.1 131.1 320.1 128 330.4 128 346.9 128 362.3 136 371.7 149.5L437.3 243.2 354.8 300.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/capsules.js
// module id = 3U7c
// module chunks = 144